import { withLocalState } from 'pyradux';

import BitcoinTradesContainer from './BitcoinTrades.container';
import reducer from './BitcoinTrades.reducer';
import BitcoinTradesSagas from './BitcoinTrades.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'bitcoinTrades',
  sagas: [BitcoinTradesSagas],
};

export default withLocalState(withLocalStateOptions, BitcoinTradesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BitcoinTrades/index.js